import { passwordCardHeader } from "./password-card-header";
import { passwordCardDeleteModal } from "./password-card-delete-modal";

export const passwordCard = {
	columns: {
		cardOwner: "Dono do cartão",
		permissions: "Ações que autoriza",
		cardNumber: "Número do cartão",
		timeCreation: "Data/Hora Criação",
		cardCreator: "Criador do cartão",
		cardStatus: "Status do cartão",
		authorizedTransactioneration: "Operação/Transação autorizada",
		value: "Valor",
		date: "Data/Hora",
		pdvId: "Id do PDV",
		employeeName: "Funcionário",
		sourceId: "Id da transação",
	},
	statusEmployeeCard: {
		active: "Ativo",
		inactive: "Inativo",
		blocked: "Bloqueado",
	},
	stockHistory: "Histórico de ações",
	blockCard: "Bloquear cartão",
	passwordCardHeader,
	passwordCardDeleteModal,
	filename: "historico_de_acoes",
};
